// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SummaryHistoryForm .h4,
.SummaryHistoryForm label,
.SummaryHistoryForm .SummaryHistoryFormHeader,
.SummaryHistoryForm .SummaryHistoryFormHistoryTitle {
  color: var(--bs-primary);
}
.SummaryHistoryForm .SummaryHistoryFormHeader > .col {
  display: flex;
  flex-direction: column;
}
.SummaryHistoryForm .SummaryHistoryFormHeader > .col .SummaryHistoryFormTitle {
  padding: 0.25rem 0 1rem 0;
  border-bottom: 1px solid #ccc;
  text-transform: uppercase;
}
.SummaryHistoryForm .SummaryHistoryFormLinkTrips {
  padding-bottom: 0.5rem;
}
.SummaryHistoryForm .SummaryHistoryFormLinkTrips > .col {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.SummaryHistoryForm .SummaryHistoryFormSectionHeader {
  padding-bottom: 1rem;
}
.SummaryHistoryForm .SummaryHistoryFormSectionHeader .SummaryHistoryFormCommentsTitle {
  padding: 0.5rem 0 1rem 0;
  border-bottom: 1px solid #ccc;
  text-transform: uppercase;
}
.SummaryHistoryForm .TextArea {
  height: 4rem;
  resize: none;
}
.SummaryHistoryForm .AddCityButton .sv {
  position: relative;
  top: -1px;
  margin-right: 0.25rem;
  color: green;
}
.SummaryHistoryForm .btn {
  text-transform: uppercase;
}
.SummaryHistoryForm .btn[type=SUBMIT] {
  width: 100%;
  margin: 2rem 0;
}`, "",{"version":3,"sources":["webpack://./src/features/SummaryHistory/components/SummaryHistoryForm/styles.scss"],"names":[],"mappings":"AACE;;;;EAIE,wBAAA;AAAJ;AAGI;EACE,aAAA;EACA,sBAAA;AADN;AAEM;EACE,yBAAA;EACA,6BAAA;EACA,yBAAA;AAAR;AAIE;EACE,sBAAA;AAFJ;AAGI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AADN;AAIE;EACE,oBAAA;AAFJ;AAGI;EACE,wBAAA;EACA,6BAAA;EACA,yBAAA;AADN;AAIE;EACE,YAAA;EACA,YAAA;AAFJ;AAKI;EACE,kBAAA;EACA,SAAA;EACA,qBAAA;EACA,YAAA;AAHN;AAME;EACE,yBAAA;AAJJ;AAKI;EACE,WAAA;EACA,cAAA;AAHN","sourcesContent":[".SummaryHistoryForm {\n  .h4,\n  label,\n  .SummaryHistoryFormHeader,\n  .SummaryHistoryFormHistoryTitle {\n    color: var(--bs-primary);\n  }\n  .SummaryHistoryFormHeader {\n    > .col {\n      display: flex;\n      flex-direction: column;\n      .SummaryHistoryFormTitle {\n        padding: 0.25rem 0 1rem 0;\n        border-bottom: 1px solid #ccc;\n        text-transform: uppercase;\n      }\n    }\n  }\n  .SummaryHistoryFormLinkTrips {\n    padding-bottom: 0.5rem;\n    > .col {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n    }\n  }\n  .SummaryHistoryFormSectionHeader {\n    padding-bottom: 1rem;\n    .SummaryHistoryFormCommentsTitle {\n      padding: 0.5rem 0 1rem 0;\n      border-bottom: 1px solid #ccc;\n      text-transform: uppercase;\n    }\n  }\n  .TextArea {\n    height: 4rem;\n    resize: none;\n  }\n  .AddCityButton {\n    .sv {\n      position: relative;\n      top: -1px;\n      margin-right: 0.25rem;\n      color: green;\n    }\n  }\n  .btn {\n    text-transform: uppercase;\n    &[type='SUBMIT'] {\n      width: 100%;\n      margin: 2rem 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
